import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTheme } from "styled-components";

import UserInformation from "../../../components/PrinterBrowsedClientDetails/UserInformation";
import UserProfile from "../../../components/UserDetails/UserProfile";
import { Divider, NavigateBack, Typography } from "../../../designComponents";
import { requestAPI } from "../../../utils";
import { ViewJobContainerStyled } from "../../BrowseJobs/BrowseJobDetails/style";
import techniciansJobApi from "../../../APIs/technicians";
import LicensesAndCertificationsView from "./TechnicianDocuments";
import adminApi from "../../../APIs/admin";

const TechnicianDetail = () => {
  const theme = useTheme();
  const { technicianId } = useParams();
  const [singleTechnician, setSingleTechnician] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const handleApprove = async () => {
    try {
      setLoading(true);
      await requestAPI(
        adminApi.approveTechnician({
          userId: singleTechnician?.user?._id ?? "",
        }),
      );
      getSingleTechnician();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowConfirm(false);
    }
  };
  const getSingleTechnician = async () => {
    try {
      if (!technicianId) return;

      setLoading(true);

      const response = await requestAPI(
        techniciansJobApi.getTechnicianById(technicianId),
      );
      setSingleTechnician(response?.data || response);
    } catch (error: any) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSingleTechnician();
  }, [technicianId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: "sticky",
          top: "60px",
          zIndex: "999",
          paddingTop: "5px",
          background: "#fff",
        }}
      >
        <NavigateBack />
      </div>

      <div className="contents">
        <Typography
          variant="heading"
          strong
          style={{ color: theme.colors.blueFade }}
        >
          Technician Details
        </Typography>

        <Divider spaceY="20px" />

        <UserProfile
          name={singleTechnician?.fullName}
          email={singleTechnician?.user?.emailAddress}
          imgUrl={singleTechnician?.avatar}
          status={singleTechnician?.approvalStatus}
          handleApprove={handleApprove}
          loading={loading}
          showConfirm={showConfirm}
          setShowConfirm={setShowConfirm}
        />

        <Divider spaceY="20px" />

        <UserInformation
          userName={singleTechnician?.fullName || ""}
          userType={singleTechnician?.role || ""}
          userEmail={singleTechnician?.user?.emailAddress || ""}
          userAddress={
            singleTechnician?.contactInfo?.address1
              ? `${singleTechnician.contactInfo.address1}, ${singleTechnician.contactInfo.city}`
              : "Tinkune, Kathmandu"
          }
          contactNumber={singleTechnician?.contactInfo?.phoneNumber || ""}
        />
        <LicensesAndCertificationsView
          licenses={singleTechnician?.licenses}
          certifications={singleTechnician?.certifications}
        ></LicensesAndCertificationsView>
      </div>
    </ViewJobContainerStyled>
  );
};

export default TechnicianDetail;
